import { Draft } from '../core/models';

export type Unsubscribe = () => void;

export interface Store {
  /**
   * Get a single draft by ID
   */
  get(id: string): Promise<Draft | null>;

  /**
   * List all drafts, ordered by most recent first
   */
  list(): Promise<Draft[]>;

  /**
   * Save or update a draft
   */
  put(draft: Draft): Promise<void>;

  /**
   * Delete a draft by ID
   */
  remove(id: string): Promise<void>;

  /**
   * Subscribe to changes in the store
   * @returns Unsubscribe function
   */
  onChange(callback: () => void): Unsubscribe;
}

/**
 * Error thrown when a store operation fails
 */
export class StoreError extends Error {
  constructor(
    message: string,
    public readonly operation: 'get' | 'list' | 'put' | 'remove',
    public readonly cause?: unknown
  ) {
    super(message);
    this.name = 'StoreError';
  }
} 